module.exports = __webpack_public_path__ + "static/media/vn.59020f42.svg";